export const PHONE_DISPLAY = "062 726 5479";
export const EMAIL = "info@cherryblossomgifts.co.za";
export const INSTAGRAM = "https://www.instagram.com/Cherryblossomgift";

export const waLink = (message) =>
    `https://wa.me/27627265479?text=${encodeURIComponent(message)}`;

export const WA_MESSAGES = {
    general: "Hi Cherry Blossom Gifts! I'd like to place an order.",
    mug: "Hi Cherry Blossom Gifts! I'd like to order a Personalized Mug (R100 each).",
    ramadhaan:
        "Hi Cherry Blossom Gifts! I'm interested in the Ramadhaan Gift Set special (Sehri & Iftaar mugs, dates, Zam Zam & a Dua-a-Day booklet).",
    tshirt: "Hi Cherry Blossom Gifts! I'd like a quote for Personalized T-Shirts.",
    mousepad: "Hi Cherry Blossom Gifts! I'd like a quote for Personalized Mouse Pads.",
    keyring: "Hi Cherry Blossom Gifts! I'd like a quote for Personalized Key Rings.",
    masonjar:
        "Hi Cherry Blossom Gifts! I'd like to order a Mason Jar 350ml (clear or frosted, with lid & straw — R130).",
    custom: "Hi Cherry Blossom Gifts! I have a custom gift idea I'd like to chat about.",
};

export const IMAGES = {
    hero: "https://static.prod-images.emergentagent.com/jobs/6c29a052-0528-43dc-be50-24a30a76807b/images/5c9ec54b9175eb60844fc60ea2c73ecdb6c5f6747c3ea88724ac54b1ac1e35b5.jpeg",
    mug: "https://static.prod-images.emergentagent.com/jobs/6c29a052-0528-43dc-be50-24a30a76807b/images/94126d090736dc4457fde9f9e400b12ce88a667668e2c49b2c5e59f078bddd4f.jpeg",
    tshirt:
        "https://static.prod-images.emergentagent.com/jobs/6c29a052-0528-43dc-be50-24a30a76807b/images/fefef20084b4c9d2697f91b48298def0df51cbec5bf7789fb997d2aaee04684e.jpeg",
    mousepad:
        "https://static.prod-images.emergentagent.com/jobs/6c29a052-0528-43dc-be50-24a30a76807b/images/6e200153abffe6b5ed6fd1f9a49718f8917d1461ad8aedf58ddf0e8573c97aa1.jpeg",
    keyring:
        "https://static.prod-images.emergentagent.com/jobs/6c29a052-0528-43dc-be50-24a30a76807b/images/1e13fcfb9bf5872b2ea0e4a1d9949808878ed704ce358164e1c73827e8209b94.jpeg",
    ramadhaan: "/work/ramadhaan.jpg",
    heroWork: "/work/g02.jpg",
    petalsWide:
        "https://static.prod-images.emergentagent.com/jobs/6c29a052-0528-43dc-be50-24a30a76807b/images/6bbc7b35724e7f5e6054a97db8ad1a762b950c24ebe5e2b958a96ccee00eaf78.jpeg",
    masonJar: "/work/g00.jpg",
};

export const GALLERY = [
    { src: "/work/g22.jpg", caption: "Gift-boxed mug with grey ribbon" },
    { src: "/work/g01.jpg", caption: "Personalized baby onesie" },
    { src: "/work/g19.jpg", caption: "‘I was raised by a woman…’ photo mug" },
    { src: "/work/g10.jpg", caption: "Ducks mood-chart mug" },
    { src: "/work/g02.jpg", caption: "Bismillah sakura mug & friends" },
    { src: "/work/g21.jpg", caption: "Family photo collage mug" },
    { src: "/work/g20.jpg", caption: "Custom photo + quote mug" },
    { src: "/work/g15.jpg", caption: "Personalized logo mug" },
];

export const PRODUCTS = [
    {
        id: "mug",
        name: "Personalized Mug",
        desc: "Glossy ceramic mug printed with their name, photo or favourite quote.",
        price: "R100",
        priceNote: "each",
        badge: "Best Seller",
        img: IMAGES.mug,
        msg: WA_MESSAGES.mug,
    },
    {
        id: "tshirt",
        name: "Personalized T-Shirt",
        desc: "Soft premium tees with vibrant custom prints that outlast the wash.",
        price: "On WhatsApp",
        priceNote: "",
        badge: "Custom Print",
        img: IMAGES.tshirt,
        msg: WA_MESSAGES.tshirt,
    },
    {
        id: "mousepad",
        name: "Personalized Mouse Pad",
        desc: "Smooth-glide fabric top, anti-slip base, printed edge to edge.",
        price: "On WhatsApp",
        priceNote: "",
        badge: "Desk Essential",
        img: IMAGES.mousepad,
        msg: WA_MESSAGES.mousepad,
    },
    {
        id: "keyring",
        name: "Personalized Key Ring",
        desc: "Little keepsakes — names, initials or a mini photo they carry everywhere.",
        price: "On WhatsApp",
        priceNote: "",
        badge: "Keepsake",
        img: IMAGES.keyring,
        msg: WA_MESSAGES.keyring,
    },
    {
        id: "masonjar",
        name: "Mason Jar · 350ml",
        desc: "Clear or frosted glass with lid and straw — your design, or we'll design for you.",
        price: "R130",
        priceNote: "each",
        badge: "New Arrival",
        img: IMAGES.masonJar,
        msg: WA_MESSAGES.masonjar,
    },
];

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -96 });
    else el.scrollIntoView({ behavior: "smooth" });
};
